import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { components } from '@/api/qraft/schema';
import { formatLongDate } from '~/utils/dateFormat';

type StudyHelperBoardItem = components['schemas']['StudyHelperBoardItem'];

interface HelperInfoBlockProps {
  label: string;
  helper: StudyHelperBoardItem;
}

export function HelperInfoBlock({ label, helper }: HelperInfoBlockProps) {
  const { t } = useTranslation();

  return (
    <div>
      <InfoBlockLabel>{label}</InfoBlockLabel>
      <InfoRow>
        <InfoKey>{t('lessons.study-helper-name-2')}</InfoKey>
        <InfoValue>{helper.display_name}</InfoValue>
      </InfoRow>
      <InfoRow>
        <InfoKey>{t('wbs.registered-at')}</InfoKey>
        <InfoValue>
          {helper.registered ? formatLongDate(helper.registered) : '—'}
        </InfoValue>
      </InfoRow>
      <InfoRow>
        <InfoKey>{t('wbs.response-rate-2')}</InfoKey>
        <InfoValue>
          {helper.response_rate != null ? `${helper.response_rate}%` : '—'}
        </InfoValue>
      </InfoRow>
      <InfoRow>
        <InfoKey>{t('lessons.active-students-2')}</InfoKey>
        <InfoValue>{helper.active_students ?? '—'}</InfoValue>
      </InfoRow>
    </div>
  );
}

const InfoBlockLabel = styled.p`
  color: var(--grey-900);
  font-family: var(--raleway);
  font-size: 18px;
  font-weight: 400;
  margin: 0 0 38px 0;
`;

const InfoRow = styled.div`
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
`;

const InfoKey = styled.span`
  color: var(--grey-800);
  font-family: var(--raleway);
  font-size: 13px;
  font-weight: 600;
  min-width: 160px;
  text-transform: uppercase;
`;

const InfoValue = styled.span`
  color: var(--grey-800);
  font-family: var(--open-sans);
  font-size: 13px;
`;
